import { API } from "aws-amplify";
import React from "react";
import InputField from "../../../../_shared/components/InputField/InputField";
import { useModal } from "../../../../_shared/contexts/ModalContext";
import { ProfileForm } from "../../models/ProfileForm";

interface Props {
  isVerified: boolean;
  setProfileForm: (form: ProfileForm) => void;
}

export const VerifyPhoneBadge: React.FC<Props> = ({
  isVerified,
  setProfileForm,
}) => {
  const { onErrorMsg, onSuccessMsg } = useModal();

  const handleVerify = async () => {
    setProfileForm({
      label: "phone verification",
      fields: [
        {
          label: "Verification code",
          name: "code",
        },
      ],
      customOnSubmit: async (values) => {
        const response = await API.post(
          "auth",
          "/cognito/checkSmsVerification",
          { body: { code: values.code } },
        );
        if (response.status === "approved") {
          onSuccessMsg("Phone number verified!");
        } else {
          onErrorMsg(`Sorry, we couldn't verify your phone number`);
        }
      },
      customInputs: (
        <div
          style={{
            textAlign: "right",
          }}
        >
          <InputField dark name="code" placeholder="Verification code" />
          <button
            type="button"
            style={{
              marginTop: "1rem",
              color: "rgb(117, 206, 65)",
              border: "none",
              background: "none",
              cursor: "pointer",
            }}
          >
            Resend code
          </button>
        </div>
      ),
    });
    await API.post("auth", "/cognito/sendSmsVerification", {});
  };

  return (
    <div
      className="row profile-row"
      style={{ marginTop: -45, borderWidth: 0, marginBottom: -15 }}
    >
      <div className="column-1"></div>
      <div
        className="column-2"
        style={{ fontSize: 11, color: "grey", width: 200 }}
      >
        {isVerified ? (
          <div data-testid="phone-verified">
            <p className="verified">
              <i className="fas fa-check checkmark"></i>
              <i
                style={{ fontSize: ".8rem", color: "#666666" }}
                className="fas fa-shield-alt"
              ></i>
              <i className="fas fa-shield-alt shieldX"></i>
              <span style={{ position: "relative", right: "5.5%" }}>
                &nbsp;Verified
              </span>
            </p>
          </div>
        ) : (
          <div
            style={{ cursor: "pointer" }}
            data-testid="phone-unverified"
            onClick={handleVerify}
          >
            <p className="unverified">
              <i
                style={{ fontSize: ".7rem", color: "#666666" }}
                className="fas fa-shield-alt"
              ></i>
              <i className="fas fa-shield-alt shieldX"></i>
              <span style={{ position: "relative", right: "5.5%" }}>
                &nbsp;Verify Number
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
